export default {
    'bond-number': 'رقم السند',
    new: 'جديد',
    'cash-statement': 'كشف الصندوق',
    add: 'إضافة',
    'posted-journals-balance': 'رصيد السندات المرحلة',
    edit: 'تعديل',
    'save-bond': 'حفظ السند',
    save: 'حفظ',
    bond: 'السند',
    not: 'غير',
    posted: 'مُرحّل',

    'delete-cash-entry': 'حذف القيد النقدي',
    'are-you-sure-you-want-delete-the-entry' : 'هل أنت متأكد من حذف القيد؟ سيتم حذف القيد المركب المُتعلق به أيضاً.',

    'add-bond': 'إضافة سند',
    'bond-date': 'تاريخ سند',
    create: 'إنشاء',
    cancel: 'إلغاء',
    warning: 'تنبيه',
    'No-fund-has-been-set-for-the-financial-file-yet': 'لم يتم تعيين صندوق للملف المالي بعد!',
    sum: 'المجموع:',
    'total-imports': 'واردات:',
    'total-exports': 'مصروفات:',
    'difference': 'الفرق:',

    'incoming-coins': 'دخل بالعملة الأجنبية:',
    'outcome-coins': 'مصروف بالعملة الأجنبية:',

    'currency-equivalent': 'الرصيد بعملة مختلفة ',
    'select-currency-to-show-the-currency-equivalent': 'اختر العملة لعرض القيمة المُكافئة',

    'make-sure-the-data-entered-is-correct': 'تأكد من صحة البيانات المدخلة',

    headers: {
        sequence: 'تسلسل',
        account: 'الحساب',
        debit: 'الصادر',
        credit: 'الوارد',
        note: 'البيان',
        currency: 'العملة',
        'currency-debit': 'ع.مدينة',
        'currency-credit': 'ع.دائنة',
        price: 'السعر',
        'paper-document-no': 'م.الورقي',
        'date': 'التاريخ',
    },

    'not-posted-bonds': 'سندات غير مُرحّلة',
    'all-bonds-are-posted': 'جميع السندات مُرحلة',

    'context-menu': {
        'account-statement' : 'كشف حساب',
        'edit' : 'تعديل',
        'delete' : 'حذف'
    },

    'revolving-balance': 'الرصيد المدور:'
}